import { Typography } from 'components/DesignSystemV2/Typography';
import React from 'react';
import { LinearThinkingPopoverWithData } from '../Differences';
import Bulb from '../icons/Bulb';
import styled from 'styled-components';
import { colorsV2 } from 'style/colors-v2';

const StyledBulletListItem = styled.div`
  display: flex;
  align-items: center;

  > svg {
    &:first-child {
      margin-right: 8px;
    }
  }
`;

const Include = styled(Typography).attrs({ color: colorsV2.black80 })``;

const Includes = styled.div`
  display: grid;
  grid-template-columns: 20px 1fr;
  align-items: center;
  gap: 12px 8px;
`;

const BookIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 18H7"
      stroke="#7C7F88"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 21H19C19.552 21 20 20.552 20 20V15H7C5.343 15 4 16.343 4 18V18C4 19.657 5.343 21 7 21Z"
      stroke="#7C7F88"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 7H15"
      stroke="#7C7F88"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 11H15"
      stroke="#7C7F88"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 3V15"
      stroke="#7C7F88"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 18V6C4 4.343 5.343 3 7 3H19C19.552 3 20 3.448 20 4V15"
      stroke="#7C7F88"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SchoolIcon = ({ color = '#7C7F88' }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.167 6.167H13V5C13 3.895 13.895 3 15 3H16.167V4.167C16.167 5.271 15.271 6.167 14.167 6.167V6.167Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 13.0002C10.843 13.0002 9.09497 11.2522 9.09497 9.09521"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.09497 9.09502C9.09497 7.39102 9.87597 6.16602 11.438 6.16602"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 13.0002C15.157 13.0002 16.905 11.2522 16.905 9.09521"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.905 9.09502C16.905 7.39102 16.124 6.16602 14.562 6.16602"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.562 6.16699C13.781 6.16699 13.338 6.41699 13 6.41699C12.662 6.41699 12.219 6.16699 11.438 6.16699"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.625 13H7.375C6.27 13 5.375 13.895 5.375 15V15C5.375 16.105 6.27 17 7.375 17H20.625"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.12 13V17"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.625 17H5.375C4.27 17 3.375 17.895 3.375 19V19C3.375 20.105 4.27 21 5.375 21H18.625"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.12 17V21"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const ClockIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.641 15.9998L11.719 13.0638V6.73584"
      stroke="#7C7F88"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.364 5.63604C21.8787 9.15076 21.8787 14.8492 18.364 18.3639C14.8493 21.8787 9.1508 21.8787 5.6361 18.3639C2.12138 14.8492 2.12138 9.15074 5.6361 5.63604C9.15082 2.12132 14.8493 2.12132 18.364 5.63604"
      stroke="#7C7F88"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const StarIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.73124 20.833C7.22417 21.0977 6.61072 21.0511 6.14946 20.7129C5.68819 20.3746 5.45933 19.8035 5.55933 19.2404L6.36867 14.6014L2.96125 11.3361C2.54475 10.9389 2.39211 10.3385 2.56835 9.79059C2.74458 9.24271 3.21864 8.84388 3.7886 8.764L8.51957 8.08772L10.6555 3.82694C10.9087 3.31595 11.4297 2.99268 12 2.99268C12.5703 2.99268 13.0913 3.31595 13.3446 3.82694L15.4805 8.08772L20.2114 8.764C20.7814 8.84388 21.2555 9.24271 21.4317 9.79059C21.6079 10.3385 21.4553 10.9389 21.0388 11.3361L17.6314 14.6014L18.4407 19.2414C18.5407 19.8045 18.3118 20.3756 17.8506 20.7139C17.3893 21.0521 16.7759 21.0987 16.2688 20.834L12 18.6281L7.73124 20.833Z"
      stroke="#7C7F88"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const ComputerIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 10.5V5C20 3.895 19.105 3 18 3H5C3.895 3 3 3.895 3 5V15"
      stroke="#7C7F88"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 18H3C2.448 18 2 17.552 2 17V16C2 15.448 2.448 15 3 15H15"
      stroke="#7C7F88"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 21H16C15.448 21 15 20.552 15 20V11.5C15 10.948 15.448 10.5 16 10.5H21C21.552 10.5 22 10.948 22 11.5V20C22 20.552 21.552 21 21 21Z"
      stroke="#7C7F88"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 18H22"
      stroke="#7C7F88"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const CommentIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.333 3H4.667C3.746 3 3 3.746 3 4.667V13"
      stroke="#7C7F88"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5 21L15.167 17.667H19.334C20.254 17.667 21 16.92 21 16V7.667C21 6.746 20.254 6 19.333 6H7.667C6.746 6 6 6.746 6 7.667V16C6 16.92 6.746 17.667 7.667 17.667H11"
      stroke="#7C7F88"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 10H17"
      stroke="#7C7F88"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 14H14"
      stroke="#7C7F88"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const LoveCommentIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.30034 17.9278L11.1359 20.3758C11.5679 20.9518 12.4319 20.9518 12.8639 20.3758L14.6994 17.9278H17.7599C19.3506 17.9278 20.6399 16.6386 20.6399 15.0478V6.40783C20.6399 4.81711 19.3506 3.52783 17.7599 3.52783H6.23986C4.64914 3.52783 3.35986 4.81711 3.35986 6.40783V15.0478C3.35986 16.6386 4.64914 17.9278 6.23986 17.9278H9.30034Z"
      stroke="#505460"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9999 8.18992C12.3426 7.80304 12.9359 7.36816 13.8392 7.36816C15.4203 7.36816 16.4802 8.7976 16.4802 10.1301C16.4802 12.9141 12.8859 15.0482 11.9999 15.0482C11.1138 15.0482 7.51953 12.9141 7.51953 10.1301C7.51953 8.7976 8.57937 7.36816 10.1605 7.36816C11.0639 7.36816 11.6571 7.80304 11.9999 8.18992Z"
      stroke="#505460"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const UserProfileCheckIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="11.9998"
      cy="8.89044"
      r="4.25177"
      stroke="#505460"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.99658 20.6454C3.99658 18.1594 6.01242 16.1436 8.49846 16.1436H11.0825"
      stroke="#505460"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.0027 17.582L16.0014 20.5833L14.2017 18.7825"
      stroke="#505460"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CourseInfo = ({ totalHours, showCommitment, mounted, level }) => {
  return (
    <div className="course-info">
      <Typography
        style={{
          marginBottom: '12px',
          marginTop: '8px',
          position: 'relative',
          zIndex: 1
        }}
        variant="semi-bold/16-24"
      >
        Khoá học này bao gồm
      </Typography>
      {mounted ? (
        <LinearThinkingPopoverWithData
          needExpandArea
          position={['bottom right']}
        >
          <StyledBulletListItem>
            <Bulb color={colorsV2.primary100} />

            <div>
              <Typography
                variant="regular/14-20"
                style={{
                  color: colorsV2.primary100
                }}
              >
                Linearthinking
              </Typography>
            </div>
          </StyledBulletListItem>
        </LinearThinkingPopoverWithData>
      ) : null}
      <Includes style={{ position: 'relative', zIndex: 1 }}>
        {showCommitment && (
          <>
            <UserProfileCheckIcon />
            <Include>Đảm bảo đầu ra</Include>
          </>
        )}

        <ClockIcon />
        <Include>{totalHours} giờ học trên lớp</Include>

        <SchoolIcon />
        <Include>Sử dụng công nghệ độc quyền của DOL</Include>

        <BookIcon />
        <Include>Sách giáo trình miễn phí</Include>

        {level.classGroup.includes('IELTS') && (
          <>
            <StarIcon />
            <Include>Gói chấm sửa bài trị giá 3.500k</Include>
          </>
        )}

        <ComputerIcon />
        <Include>Tài khoản dol.vn 1 năm giá 4.990k</Include>

        <LoveCommentIcon />
        <Include>Suppport ngoài giờ từ giáo viên</Include>

        <CommentIcon />
        <Include>Hỗ trợ cả trước và sau khi thi</Include>
      </Includes>
    </div>
  );
};

export const CourseInfoJunior = ({ totalHours, mounted }) => {
  return (
    <div className="course-info">
      <Typography
        style={{
          marginBottom: '12px',
          marginTop: '8px',
          position: 'relative',
          zIndex: 1
        }}
        variant="semi-bold/16-24"
      >
        Khoá học này bao gồm
      </Typography>
      {mounted ? (
        <LinearThinkingPopoverWithData
          needExpandArea
          position={['bottom right']}
        >
          <StyledBulletListItem>
            <Bulb color={colorsV2.primary100} />

            <div>
              <Typography
                variant="regular/14-20"
                style={{
                  color: colorsV2.primary100
                }}
              >
                Linearthinking độc quyền
              </Typography>
            </div>
          </StyledBulletListItem>
        </LinearThinkingPopoverWithData>
      ) : null}
      <Includes style={{ position: 'relative', zIndex: 1 }}>
        <ClockIcon />
        <Include>{totalHours} giờ học trên lớp</Include>

        <BookIcon />
        <Include>Sách giáo trình màu miễn phí</Include>

        <SchoolIcon />
        <Include>Hệ thống công nghệ superLMS</Include>

        <CommentIcon />
        <Include>Hỗ trợ sau giờ học từ giáo viên</Include>

        <LoveCommentIcon />
        <Include>Chăm sóc tận tình, báo cáo tiến độ thường xuyên</Include>
      </Includes>
    </div>
  );
};
